const OverTimeCard = ({ title, img, time, totalProjects, mostImportantProblem, section }) => {
	const [titleMostImportant] = mostImportantProblem;
	const percentage = parseFloat(((100 * time) / totalProjects).toFixed(2));

	return (
		<div
			className={`w-full h-[94px] md:w-[180px] md:h-[104px] py-2 px-4 ${
				titleMostImportant === section ? "bg-[#B64D34] text-white selected-overtime-card" : "bg-[#EFF2F5] text-[#282828]"
			} rounded flex flex-col   duration-300  select-none `}
		>
			<section className="w-full flex  justify-between items-center">
				<p className=" text-[10px] font-bold leading-normal">{title}</p>
				<img className="w-6 h-6 " src={img} alt={title} />
			</section>
			<section className="w-full py-1  h-full  flex flex-wrap justify-center   ">
				<div className=" w-full flex items-center text-right gap-3 justify-center  ">
					<p className=" w-[54px] md:w-[44px]  text-base font-bold leading-normal"> {time}</p>
					<p className="text-[10px] text-left w-[90px] font-semibold  grow">proyectos en rojo por este motivo</p>
				</div>
				<div className=" w-full flex items-center text-right gap-3 justify-center   ">
					<p className=" w-[54px] md:w-[44px] text-base font-bold"> {isNaN(percentage) ? 0 : percentage}</p>
					<p className="text-[10px] text-left w-[90px] font-normal  grow">es el promedio por año</p>
				</div>
			</section>
		</div>
	);
};

export default OverTimeCard;
